<div class="actions">
    <wms-search id="prefab-props-search-box" name="prefab-props-search-box" width="20em" (onSearch)="searchPrefabProperties($event)"></wms-search>
</div>
<div class="widgets-list-container">
    <wms-tree id="prefab-props-search-box"  [data]="bindVariableService.prefabPropsTree" (nodeClick)="bindVariableService.handleTreeNodeClick($event)" sortBy="id" icontype="plus" [externalSearchKey]="prefabSearchKey" [selectedNode]="bindVariableService.selectedNodeInBindDialog['prefab-props']"></wms-tree>
</div>